import { createElementBlock as o, openBlock as r, createElementVNode as t } from "vue";
const l = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 21 21"
};
function n(a, e) {
  return r(), o("svg", l, [...e[0] || (e[0] = [
    t("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3 4.75a.75.75 0 0 0 0 1.5h15a.75.75 0 0 0 0-1.5zm-.75 5.75A.75.75 0 0 1 3 9.75h15a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75m0 5a.75.75 0 0 1 .75-.75h15a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const c = { render: n };
export {
  c as default,
  n as render
};
